import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const NAV = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/inbox", label: "Inbox" },
  { to: "/products", label: "Products" },
  { to: "/channels", label: "Channels" },
  { to: "/agents", label: "Agent Settings" },
  { to: "/knowledge", label: "Knowledge Sources" },
  { to: "/escalation", label: "Escalation Rules" },
  { to: "/templates", label: "WhatsApp Templates" },
  { to: "/users", label: "Users" },
  { to: "/audit", label: "Audit Log" },
];

export function Layout() {
  const { user, logout } = useAuth();
  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">Qbanq Support</div>
        <nav className="nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ marginTop: 24, fontSize: 13 }} className="muted">
          {user?.email}
          <br />
          <button className="btn secondary" style={{ marginTop: 8 }} onClick={logout}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
